






































































































































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import {Gender, isNorthEastAndNorthCumbria, RiskLevelForScore, RiskTypeNameForScore} from "@/model/Model";
import { RiskLevel } from "@/model/RiskLevel";
import { removeWidows, UpdatedHeight } from "@/utils";
import ProgressBar from "./ProgressBar.vue";
import { Borough } from "@/model/Boroughs";
import SupportOverview from "@/components/SupportOverview.vue";

@Component({
  components: {
    SupportOverview,
    ProgressBar
  }
})
export default class TestResultsSummary extends Vue {
  public static navButtonClasses: string[] = ["view-results"];
  public static omitFromNavigation: boolean = true;
  public static navButtonLabel: () => string = () => "View your results";

  @Prop() public score!: number;
  @Prop() public units!: number;
  @Prop() public calories!: number;
  @Prop() public gender!: Gender;
  @Prop() public region!: Borough;
  @Prop() public commissioned!: boolean;

  public updated() {
    UpdatedHeight();
  }

  @Emit("navigate")
  private gotoSupportFinder(event: Event) {
    event.preventDefault();
    return "find-support";
  }

  private get bookingLiveLink(): string {
    switch (this.region.name) {
      case "West Sussex":
        return "https://drinkcoach.bookinglive.com/book/add/p/11";
      case "Suffolk":
        return "https://drinkcoach.bookinglive.com/book/add/p/29";
      case "Rotherham":
        return "https://drinkcoach.bookinglive.com/book/add/p/22";
      case "Essex":
        return "https://drinkcoach.bookinglive.com/book/add/p/24";
      case "Barnet":
        return "https://drinkcoach.bookinglive.com/book/add/p/14";
      case "Lambeth":
        return "https://drinkcoach.bookinglive.com/book/add/p/15";
      case "NorthEastAndNorthCumbria":
        return "https://drinkcoach.bookinglive.com/book/add/p/19";
      case "Staffordshire":
        return "https://drinkcoach.bookinglive.com/book/add/p/17";
      case "Lewisham":
        return "https://drinkcoach.bookinglive.com/book/add/p/16";
      case "Haringey":
        return "https://drinkcoach.bookinglive.com/book/add/p/20";
      case "Waltham Forest":
        return "https://drinkcoach.bookinglive.com/book/add/p/18";
      case "Barnsley":
        return "https://drinkcoach.bookinglive.com/book/add/p/13";
      case "Croydon":
        return "https://drinkcoach.bookinglive.com/book/add/p/31";
      case "Bradford District":
        return "https://drinkcoach.bookinglive.com/book/add/p/32";
      default:
        return "https://drinkcoach.bookinglive.com/";
    }
  }

  private get hasFreeAppointments(): boolean {
    return !!this.region.hasFreeAppointments;
  }

  @Emit("navigate")
  private gotoBooking(event: Event) {
    event.preventDefault();
    return "book-appointment";
  }

  private removeWidowsLocal(str: string): string {
    return removeWidows(str);
  }

  private get riskType(): string {
    return RiskTypeNameForScore(this.score);
  }

  private get riskLevel(): RiskLevel {
    return RiskLevelForScore(this.score);
  }

  private get hamburgers(): string {
    return parseFloat(
      (this.calories / 250).toFixed(1).replace(".0", "")
    ).toLocaleString();
  }

  private get genderCalLimit(): number {
    switch (this.gender) {
      case Gender.Male:
        return 2500;
      case Gender.Female:
        return 2000;
    }
  }

  private get genderName(): string {
    switch (this.gender) {
      case Gender.Male:
        return "male";
      case Gender.Female:
        return "female";
    }
  }

  private get showServiceInfoOnResultsSummaryPage(): boolean {
    return this.region.showServiceInfoOnResultsSummaryPage === true;
  }

  private get riskHeading(): string {
    switch (this.riskLevel) {
      case RiskLevel.Lower:
        return removeWidows("Keep up the good work!");
      case RiskLevel.Increasing:
        return removeWidows(
          "For Increasing Risk scores we recommend you cut down " +
            "your drinking"
        );
      case RiskLevel.Higher:
        return removeWidows(
          "For Higher Risk scores we <strong><u>strongly</u></strong> " +
            "recommend seeking advice from a health professional"
        );
      case RiskLevel.High:
        return removeWidows(
          "For High Risk / Possible Dependence scores we " +
            "<strong><u>strongly</u></strong> recommend seeking advice from a health professional"
        );
    }
  }

  @Emit("navigate")
  private handleNavigation(event: string) {
    return event;
  }

  private get isLowerRisk(): boolean {
    return this.riskLevel === RiskLevel.Lower;
  }

  private get isIncreasingRisk(): boolean {
    return this.riskLevel === RiskLevel.Increasing;
  }

  private get isHigherRisk(): boolean {
    return this.riskLevel === RiskLevel.Higher;
  }

  private get isHighRisk(): boolean {
    return this.riskLevel === RiskLevel.High;
  }

  private get isInNorthEastAndNorthCumbria(): boolean {
    return isNorthEastAndNorthCumbria();
  }
}
